import { ref, onMounted, onUnmounted, Ref } from 'vue'
/* 
收集用户鼠标点击的页面坐标
*/
export function useEmFontSize(): Ref<string> {
  // 初始化坐标数据
  const emFt = ref('')

  // 用于响应窗口尺寸该表
  const resizeFn = function () {
    const windowWidth = window.screen.width
    emFt.value = windowWidth / 7.5 + 'px'
  }

  // 挂载后绑定点击监听
  onMounted(() => {
    window.addEventListener('resize', resizeFn)
    resizeFn()
  })

  // 卸载前解绑点击监听
  onUnmounted(() => {
    window.removeEventListener('resize', resizeFn)
  })

  return emFt
}
